module.exports = __webpack_public_path__ + "static/media/3.6e1f5f0f.jpg";